import { Contacts } from 'components/contacts';
import HomeScreensWrapper from 'components/home-screens-wrapper';
import { Navigate, RouteObject } from 'react-router-dom';
import { CommonPaths } from 'routes';
import Estimate from 'screens/estimate';
import EstimateScreensWrapper from 'screens/estimate/components/estimate-screens-wrapper';
import StartPage from 'screens/start-client-page';

const NavigateToStartPage = <Navigate to={CommonPaths.home} replace />;

const commonRouter: RouteObject[] = [
  {
    path: '*',
    element: NavigateToStartPage,
  },
  {
    path: '/',
    element: NavigateToStartPage,
  },
  {
    path: CommonPaths.contacts,
    element: <Contacts />,
  },
  {
    path: CommonPaths.estimate,
    element: <EstimateScreensWrapper />,
    children: [{ path: CommonPaths.estimate, element: <Estimate /> }],
  },
  {
    path: CommonPaths.home,
    element: <HomeScreensWrapper />,
    children: [{ path: CommonPaths.home, element: <StartPage /> }],
  },
];

export default commonRouter;
